import { Select as MUISelect, outlinedInputClasses as MUIoutlinedInputClasses, formHelperTextClasses as MUIformHelperTextClasses, inputBaseClasses as MUIinputBaseClasses, inputLabelClasses as MUIinputLabelClasses, styled, InputLabel, FormHelperText, } from '@mui/material';
export const StyledInputLabel = styled(InputLabel)(({ theme }) => {
    return {
        fontSize: theme.typography['uikit-body2'].fontSize,
        fontWeight: theme.typography['uikit-body2'].fontWeight,
        lineHeight: theme.typography['uikit-body2'].lineHeight,
        [`&.${MUIinputLabelClasses.outlined}`]: {
            transform: 'translate(16px, 13.5px) scale(1)',
            [`&.${MUIinputLabelClasses.sizeSmall}`]: {
                transform: 'translate(16px, 10px) scale(1)',
            },
            [`&.${MUIinputLabelClasses.shrink}`]: {
                transform: 'translate(14px, -7px) scale(0.8)',
            },
        },
    };
});
export const StyledSelect = styled(MUISelect)(({ theme }) => {
    return {
        [`&.${MUIoutlinedInputClasses.root}`]: {
            transition: theme.transitions.create(['background', 'border-color', 'box-shadow']),
            '&:not(.Mui-focused)': {
                background: '#F9F9F9',
            },
            '&.Mui-disabled': {
                background: '#F2F2F2',
                [`& .${MUIoutlinedInputClasses.input}`]: {
                    color: '#B2B2B2',
                },
            },
            [`& .${MUIoutlinedInputClasses.input}`]: {
                padding: theme.spacing(1.9375, 2),
                fontSize: theme.typography['uikit-body2'].fontSize,
                fontWeight: theme.typography['uikit-body2'].fontWeight,
                lineHeight: theme.typography['uikit-body2'].lineHeight,
                minHeight: 17,
                height: 17,
                [`&.${MUIinputBaseClasses.inputSizeSmall}`]: {
                    padding: theme.spacing(1.4375, 1.75),
                },
            },
        },
        [`& .${MUIoutlinedInputClasses.notchedOutline}`]: {
            borderColor: theme.palette.divider,
            borderRadius: theme.shape.borderRadius / 2,
        },
    };
});
export const StyledFormHelperText = styled(FormHelperText)(({ theme }) => {
    return {
        [`& .${MUIformHelperTextClasses.root}`]: {
            fontSize: theme.typography['uikit-caption'].fontSize,
            fontWeight: theme.typography['uikit-caption'].fontWeight,
            lineHeight: theme.typography['uikit-caption'].lineHeight,
        },
    };
});
